import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'notNull' })
export class AssertNotNullPipe implements PipeTransform {
  transform<T>(value: T) {
    return value!;
  }
}
